// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","countryFlag":"countryFlag_countryFlag__aEknh"};